import { api, ApiRes } from './client'
import { PlatformMenu, PlatformMenuItem } from '@builder/types'

export const getPlatformMenus = (
    platformName: string
): ApiRes<PlatformMenu[]> => {
    return api.get(`v2/manage/platforms/${platformName}/menus`)
}

export const getPlatformMenu = (
    platformName: string,
    menuId: string
): ApiRes<PlatformMenu> => {
    return api.get(`v2/manage/platforms/${platformName}/menus/${menuId}`)
}
export const storePlatformMenu = (
    platformName: string,
    type: 'header' | 'footer'
): ApiRes<PlatformMenu> => {
    return api.post(`v2/manage/platforms/${platformName}/menus`, { type })
}

export const updatePlatformMenu = (
    platformName: string,
    menuId: string,
    items: PlatformMenuItem[]
): ApiRes<PlatformMenu> => {
    return api.put(`v2/manage/platforms/${platformName}/menus/${menuId}`, {
        items,
    })
}

export const deletePlatformMenu = (
    platformName: string,
    menuId: string
): ApiRes<void> => {
    return api.delete(`v2/manage/platforms/${platformName}/menus/${menuId}`)
}
